module.exports = __webpack_public_path__ + "static/media/times.be696167.svg";